<div class="container">
    <div [@opacity]="showing ? 'visible' : 'hidden'" class="full-height flex">
        <ng-container #portal></ng-container>
    </div>
</div>

